import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Hero from '../../hero/Hero';
import './home.css';
import Card from '../../card/Card';

const Home = () => {
	const [ updateMonthOfferEnds, setUpdateMonthOfferEnds ] = useState(new Date().getMonth() + 2);

	useEffect(
		() => {
			handleOfferEnds();
		},
		[ updateMonthOfferEnds ]
	);

	const handleOfferEnds = () => {
		setInterval(() => {
			var num = 0;
			num++;
			setUpdateMonthOfferEnds(() => new Date().getMonth() + num + num);
		}, 1000);
	};

	return (
		<React.Fragment>
			<Hero>
				<div className="background-img-home" />
			</Hero>
			<Link to="/membership" style={{ textDecoration: 'none' }}>
				<Card>
					<div className="promo-section-home">
						<h1 className="hurry-typography">Hurry!</h1>
						<div className="promo-content">
							<h1 className="discount-typography">20% off Memberships</h1>
							<div className="offer-ends-typography">
								<p>Offer Ends {updateMonthOfferEnds}/21</p>
							</div>
						</div>
					</div>
				</Card>
			</Link>
			<h1 className="fitness-class-typography">Fitness Class</h1>
			<div className="fitness-class-container">
				<div className="weekend-card">
					<h1 className="weekend-training-typography">Weekend Training</h1>
					<h3 className="weekend-date-typography">Sat. 21 - 1PM/EST</h3>
				</div>
				<div className="one-on-one-card">
					<h1 className="one-on-one-typography">1-on-1 Fitness Training</h1>
					<h3 className="coming-soon-typography">Coming Soon...</h3>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Home;
